import React from 'react';

import classNames from 'classnames';
import './font-editor.less';
import { Select } from 'antd';
import BrandingService from '../../services/branding';

export default class Editor extends React.Component {
    state = {
        fontFamilies: []
    };


    componentDidMount() {
        this.load();
    }

    render() {
        const {
            onChange,
            value,
            className,
            allowClear,
            readOnly,
            disabled
        } = this.props;

        const { fontFamilies } = this.state;

        return (
            <span className={ classNames( 'font-family-editor', className ) }>
                <Select
                    allowClear={ allowClear }
                    value={ value ?  value : '' }
                    onChange={ onChange }
                    readOnly={ readOnly }
                    disabled={ disabled }
                >
                    <Select.Option
                            value=''>
                        <div>
                            Poppins (Default)
                        </div>
                    </Select.Option>
                {
                    fontFamilies.map( font => (
                        <Select.Option
                            key={ font.id }
                            value={ font.value }
                        >
                            <div>
                                { font.name }
                            </div>
                        </Select.Option>
                    ) )
                }

                </Select>
            </span>
        );
    }


    load = async () => {

        this.setState( {
            loading: true
        } );

        try {
            const brandingService = new BrandingService( this.props.auth.state );
            const response = await brandingService.getFontFamilies();
            const fonts = response.fonts.map( f=> {
                return {
                    id: f.id,
                    name: f.name,
                    value: f.value
                };
            } );

            this.setState( {
                loading: false,
                fontFamilies: fonts
            } );
        } catch ( { errors } ) {
            this.setState( {
                loading: false,
                loadingErrors: errors
            } );
        }
    };
}
